import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [],
  templateUrl: './app-link.component.html',
  styleUrl: './app-link.component.scss'
})
export class AppLinkComponent {
    @Input({ required: true }) subtitle!: string;

    get capitalizedSubtitle(): string {
        return this.subtitle.charAt(0).toUpperCase() + this.subtitle.slice(1);
    }
}
